import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Fattura } from '../../../models/fattura';

@Component({
    selector: '[add_doc_to_fattura]',
  templateUrl: 'add-to-fattura.component.html',
})

export class AddDocumentoToFatturaComponent {
  @Input()
  fattura: Fattura;
  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(fattura: Fattura) {
    this.onClickAddToEntity.emit(fattura);
  }
}
